

export default class UpdateCategoryTranslationRequest  {
	LangCode?: string = '';
	Name?: string = '';
	constructor(obj?: Partial<UpdateCategoryTranslationRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
